import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';

import { filterByString } from '@topconagriculture/frontend-utils';

import { trimWhitespace } from '../../../core/helpers/utils/utils';
import { Forms } from '../../form/form.selector';
import { RootState } from '../../reducers';
import { getPremixes } from '../premixes/premixes.selector';
import { Recipe, RecipeFilterFormPayload } from './recipes.types';
import { Premix } from '../premixes/premixes.types';

export const getRecipes = (state: RootState): Recipe[] => state.entities.recipes;

const recipesFilterFormSelector: any = getFormValues(Forms.recipesFilterForm);

const recipeNameFilterSelector = createSelector(
  [recipesFilterFormSelector],
  (values: RecipeFilterFormPayload | undefined) => values?.rationName || '',
);
const recipeNotInUseSelector = createSelector(
  [recipesFilterFormSelector],
  (values: RecipeFilterFormPayload | undefined) => values?.hideNotInUse,
);

export const getRecipesFiltered = createSelector(
  [getRecipes, recipeNameFilterSelector, recipeNotInUseSelector],
  (recipeList: Recipe[], rationNameFilter: string, recipeNotInUseFilter: boolean): Recipe[] =>
    rationNameFilter || recipeNotInUseFilter
      ? recipeList.filter((recipe) => {
          const matchesUsage = recipeNotInUseFilter ? !recipe.notInUse : true;
          const matchesName =
            filterByString(recipe.displayName, trimWhitespace(rationNameFilter)) ||
            filterByString(recipe.description, trimWhitespace(rationNameFilter));

          return matchesUsage && matchesName;
        })
      : recipeList,
);

export const getRecipesInUseFiltered = createSelector([getRecipesFiltered], (recipeList: Recipe[]): Recipe[] =>
  recipeList.filter((recipe) => !recipe.notInUse),
);

export const findRecipeById = (
  recipes: Recipe[],
  premixes: Premix[],
  rationId: string,
): Recipe | Premix | undefined => {
  return [...recipes, ...premixes].find((recipe) => recipe.id === rationId);
};

export const getRecipeById = createSelector(
  [getRecipes, getPremixes],
  (recipes: Recipe[], premixes: Premix[]) => (rationId: string) => findRecipeById(recipes, premixes, rationId),
);
